var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('title-row', {
    attrs: {
      "title": "Adminisztrátorok",
      "subtitle": this.dataTable.itemsLength === -1 ? 'Betöltés...' : `${this.dataTable.itemsLength} adminisztrátor van a rendszerben`,
      "breadcrumb-items": [{
        text: 'Adminisztrátorok',
        disabled: true
      }]
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_vm.hasRight('USER_WRITE') ? _c('title-row-button', {
          attrs: {
            "to": {
              name: 'NewUser'
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-plus")]), _vm._v(" Új adminisztrátor ")], 1) : _vm._e()];
      },
      proxy: true
    }])
  }), _c('list-filter', {
    attrs: {
      "search": _vm.search
    }
  }, [_c('v-col', {
    attrs: {
      "cols": 12,
      "sm": 4,
      "md": 3
    }
  }, [_c('v-text-field', {
    staticClass: "my-4 my-sm-0",
    attrs: {
      "label": "Név / E-mail",
      "dense": "",
      "clearable": "",
      "hide-details": "",
      "filled": ""
    },
    on: {
      "input": _vm.searchEventHandler
    },
    model: {
      value: _vm.search.keyword,
      callback: function ($$v) {
        _vm.$set(_vm.search, "keyword", $$v);
      },
      expression: "search.keyword"
    }
  })], 1)], 1), _c('v-card', {
    staticClass: "rounded-xl",
    attrs: {
      "flat": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "loading": _vm.loading,
      "headers": _vm.dataTable.headers,
      "items": _vm.dataTable.items,
      "server-items-length": _vm.dataTable.itemsLength,
      "options": _vm.dataTable.options,
      "footer-props": _vm.$config.dataTableFooterProps,
      "item-class": _vm.itemClass
    },
    on: {
      "update:options": function ($event) {
        return _vm.$set(_vm.dataTable, "options", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: `item.name`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('v-avatar', {
          staticClass: "rounded-sm mr-2",
          attrs: {
            "color": "grey lighten-4",
            "size": "32"
          }
        }, [_c('v-icon', {
          attrs: {
            "size": "24",
            "color": "grey"
          }
        }, [_vm._v("mdi-account")])], 1), _vm._v(" " + _vm._s(item.name) + " "), !!Number(item.superadmin) ? _c('v-avatar', {
          staticClass: "ml-1",
          attrs: {
            "color": "primary",
            "size": "20",
            "title": "Superadmin"
          }
        }, [_c('v-icon', {
          attrs: {
            "size": "14",
            "color": "white"
          }
        }, [_vm._v(" mdi-star ")])], 1) : _vm._e(), !!Number(item.apiuser) ? _c('v-avatar', {
          staticClass: "ml-1",
          attrs: {
            "color": "grey lighten-2",
            "size": "20",
            "title": "API felhasználó"
          }
        }, [_c('v-icon', {
          attrs: {
            "size": "14",
            "color": "white"
          }
        }, [_vm._v(" mdi-chip ")])], 1) : _vm._e()];
      }
    }, {
      key: `item.actions`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm.hasRight('USER_WRITE') ? _c('v-btn', {
          staticClass: "rounded-sm m-3",
          attrs: {
            "disabled": !!(!Number(_vm.$store.state.user.superadmin) && Number(item.superadmin)),
            "text": "",
            "fab": "",
            "small": "",
            "color": "primary",
            "to": {
              name: 'UserEditor',
              params: {
                id: item.element_id
              }
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-pencil")])], 1) : _vm._e(), _vm.hasRight('USER_WRITE') ? _c('v-btn', {
          staticClass: "rounded-sm m-3",
          attrs: {
            "disabled": !!(!Number(_vm.$store.state.user.superadmin) && Number(item.superadmin)),
            "text": "",
            "fab": "",
            "small": "",
            "color": "primary",
            "title": "Archiválás"
          },
          on: {
            "click": function ($event) {
              return _vm.archive(item);
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "error"
          }
        }, [_vm._v("mdi-archive")])], 1) : _vm._e(), _vm.hasRight('USER_WRITE') ? _c('v-btn', {
          staticClass: "rounded-sm m-3",
          attrs: {
            "disabled": !!(!Number(_vm.$store.state.user.superadmin) && Number(item.superadmin)),
            "text": "",
            "fab": "",
            "small": "",
            "color": "primary",
            "title": "Törlés"
          },
          on: {
            "click": function ($event) {
              return _vm.deleteUser(item);
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "error"
          }
        }, [_vm._v("mdi-delete")])], 1) : _vm._e()];
      }
    }], null, true)
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }